(function(angular){
    'use strict';
    class MediaListEngagementWidget {
        constructor(MediaListService, CoreUserService, EmailAnalyticsService, $translate, $timeout) {
            this.mediaListService = MediaListService;
            this.coreUserService = CoreUserService;
            this.emailAnalyticsService = EmailAnalyticsService;
            this.$translate = $translate;
            this.$timeout = $timeout;

            // Left this here as a way to quickly test any layout changes we make along the way.
            // Uncommenting out these stats will show us where we intent to get to, so we can tweak
            //   styles/responsiveness appropriately
            // this.openRate = '72%';
            // this.ctoRate = '30%';
            // this.unsubscribeRate = '1.2%';
        }

        $onInit() {
            if (this.mediaListId) {
                this.emailAnalyticsService.getMediaListAggregations(this.mediaListId).then((results) => {
                    let sentLabelString = this.$translate.instant('icm-web__media-list-engagement--emails-sent');
                    this.emailsSent = results.distributions;
                    this.emailsSentLabel = sentLabelString;
                    this.openRate = results.openRate + '%';
                    this.ctoRate = results.clickRate + '%';
                    this.unsubscribeRate = results.unsubscribeRate + '%';

                    // re-check the statistics after 2.5 seconds to ensure the up-to-date data.
                    this.checkStatisticsDelay = this.$timeout(()=>{
                        this.emailAnalyticsService.getMediaListAggregations(this.mediaListId).then((data) => {
                            this.emailsSent = data.distributions;
                            this.emailsSentLabel = sentLabelString;
                            this.openRate = data.openRate + '%';
                            this.ctoRate = data.clickRate + '%';
                            this.unsubscribeRate = data.unsubscribeRate + '%';
                        });
                    }, 2500);

                    this.addDescriptionString = this.$translate.instant('icm-web__media-list-engagement--add-description');
                });
            }
        }

        $onChanges(changeObj) {
            let updatedDate = changeObj.mediaListUpdatedDate,
                updatedBy = changeObj.mediaListUpdatedBy,
                createdDate = changeObj.mediaListCreatedDate,
                createdBy = changeObj.mediaListCreatedBy;

            this.coreUserService.getCurrent(true).then((user) => {
                let userLanguage = user.language || 'en';

                switch(userLanguage) {
                    case 'zh_CN':
                    case 'zh_TW':
                        userLanguage = 'zh';
                        break;
                }
                if (updatedDate && updatedDate.currentValue && updatedBy && (updatedDate.currentValue !== updatedDate.previousValue) && (updatedBy.currentValue !== updatedBy.previousValue)) {
                    this.updatedAt = this._formatDate(new Date(updatedDate.currentValue), userLanguage);
                    this.updatedAtByText = this.$translate.instant('icm-web__media-list-engagement--edited-by', {
                        editedDate: '<b>' + this.updatedAt + '</b>',
                        editedPersion: '<b>' + this.updatedBy + '</b>'
                    }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
                }
                else if (updatedDate && updatedDate.currentValue && (updatedDate.currentValue !== updatedDate.previousValue)) {
                    this.updatedAt = this._formatDate(new Date(updatedDate.currentValue), userLanguage);
                    this.updatedAtText = this.$translate.instant('icm-web__media-list-engagement--edited', {
                        editedDate: '<b>' + this.updatedAt + '</b>'
                    }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
                }
                if (createdDate && createdBy) {
                    this.createdAt = this._formatDate(new Date(createdDate.currentValue), userLanguage);
                    this.createdAtByText = this.$translate.instant('icm-web__media-list-engagement--created-by', {
                        createdDate: '<b>' + this.createdAt + '</b>',
                        createdPerson: '<b>' + this.createdBy + '</b>'
                    }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
                }
                else if (createdDate) {
                    this.createdAt = this._formatDate(new Date(createdDate.currentValue), userLanguage);
                    this.createdAtText = this.$translate.instant('icm-web__media-list-engagement--created', {
                        createdDate: '<b>' + this.createdAt + '</b>'
                    }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
                }
            });
        }

        _formatDate(dateObj, userLanguage) {
            return dateObj.toLocaleString(userLanguage, { month: 'long'  }) + ' ' +
                dateObj.toLocaleString(userLanguage, { day: 'numeric' }) + ', ' +
                dateObj.toLocaleString(userLanguage, { year: 'numeric'});
        }

        editListHandler() {
            this.editList();
        }
    }

    angular
        .module('MW.Influencers.MediaListEngagementWidget', [
            'MW.Influencers.MediaListService',
            'MW.Framework.CoreUserService',
            'MW.Influencers.EmailAnalyticsService',
        ])
        .component('mwMediaListEngagementWidget', {
            bindings: {
                mediaListId: '<',
                mediaListName: '<',
                mediaListDescription: '<',
                mediaListUpdatedDate: '<',
                editList: '&'
            },
            controller: [
                'MediaListService',
                'CoreUserService',
                'EmailAnalyticsService',
                '$translate',
                '$timeout',
                MediaListEngagementWidget
            ],
            template: `
                <md-card>
                    <md-card-content layout-wrap layout="row" layout-align="space-between center">
                        <div class="list-details-section" flex="100" flex-gt-sm="40" layout="column" layout-align="start start">
                            <span class="list-name" layout="row">
                                {{$ctrl.mediaListName}}
                                <md-tooltip md-delay="500">
                                    {{$ctrl.mediaListName}}
                                </md-tooltip>
                            </span>
                            <span class="list-description" ng-if="$ctrl.mediaListDescription" layout="row">
                                {{$ctrl.mediaListDescription}}
                            </span>
                            <a href ng-click="$ctrl.editListHandler()" class="add-description" ng-if="!$ctrl.mediaListDescription" layout="row" layout-align="start center">
                                <span class="add-description-plus">+</span>
                                <span class="add-description-label">{{$ctrl.addDescriptionString}}</span>
                            </a>
                            <span ng-bind-html="$ctrl.createdAtByText" class="list-details" ng-show="$ctrl.createdAtByText"></span>
                            <span ng-bind-html="$ctrl.createdAtText" class="list-details" ng-show="$ctrl.createdAtText"></span>
                            <span ng-bind-html="$ctrl.updatedAtByText" class="list-details" ng-show="$ctrl.updatedAtByText"></span>
                            <span ng-bind-html="$ctrl.updatedAtText" class="list-details" ng-show="$ctrl.updatedAtText"></span>
                        </div>
                        <div class="list-stats-section" layout-wrap flex="100" flex-gt-sm="60" layout="row" layout-align="end center">
                            <span class="stat-divider" hide show-gt-sm></span>
                            <div flex class="stat-card" layout="column">
                                <span class="stat-value">
                                    {{$ctrl.emailsSent}}
                                </span>
                                <span translate class="stat-label">
                                    {{$ctrl.emailsSentLabel}}
                                </span>
                            </div>
                            <span ng-if="$ctrl.openRate" class="stat-divider"></span>
                            <div ng-if="$ctrl.openRate" flex="25" class="stat-card" layout="column">
                                <span class="stat-value">
                                    {{$ctrl.openRate}}
                                </span>
                                <span translate class="stat-label">
                                    icm-web__media-list-engagement--open-rate
                                </span>
                            </div>
                            <span ng-if="$ctrl.ctoRate" class="stat-divider"></span>
                            <div ng-if="$ctrl.ctoRate" flex="25" class="stat-card" layout="column">
                                <span class="stat-value">
                                    {{$ctrl.ctoRate}}
                                </span>
                                <span translate class="stat-label">
                                    icm-web__media-list-engagement--click-rate
                                </span>
                            </div>
                            <span ng-if="$ctrl.unsubscribeRate" class="stat-divider"></span>
                            <div ng-if="$ctrl.unsubscribeRate" flex class="stat-card" layout="column">
                                <span class="stat-value">
                                    {{$ctrl.unsubscribeRate}}
                                </span>
                                <span translate class="stat-label">
                                    icm-web__media-list-engagement--unsubscribe-rate
                                </span>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            `
        });
})(angular);